(function () {
  const outingsEventsGamesConfigurationsApp = function () {
    let gameTypeOptions;

    $('#game_type_game_type')
      .on('change', function () {
        if ($('#game_type_game_format').val() === 'custom_best_ball') {
          $(`.game-type`).addClass('d-none');
          return;
        }

        $(`.game-type.${$(this).val()}`).removeClass('d-none');
        $(`.game-type:not(.${$(this).val()})`).addClass('d-none');
      })
      .trigger('change');

    $('#game_type_game_format')
      .on('change', function () {
        $(`.game-format.${$(this).val()}`).removeClass('d-none');
        $(`.game-format:not(.${$(this).val()})`).addClass('d-none');
      })
      .trigger('change');

    $('#game_type_game_format')
      .on('change', function () {
        gameTypeOptions = gameTypeOptions || $('#game_type_game_type').html();
        if (gameTypeOptions.includes('Individual Match Play')) {
          if ($(this).val() === 'best_ball')
            $('#game_type_game_type')
              .html('')
              .append(
                $('<option>')
                  .attr('value', 'team_match_play')
                  .text('Team Match Play'),
                $('<option>')
                  .attr('value', 'team_stroke_play')
                  .text('Team Stroke Play')
              );
          else if ($(this).val() === 'custom_best_ball') {
            $('#game_type_game_type')
              .html('')
              .append(
                $('<option>')
                  .attr('value', 'team_stroke_play')
                  .text('Team Stroke Play')
              );
          } else $('#game_type_game_type').html(gameTypeOptions);
        }

        if (['666', 'best_ball'].includes($(this).val())) {
          $('#game_type_game_type [value=quota]').remove();
        } else if (['custom_best_ball'].includes($(this).val())) {
          $('.game-format.custom-best-ball').removeClass('d-none');
        } else if ($('#game_type_game_type [value=quota]').length === 0) {
          $('#game_type_game_type').append(
            $('<option>').attr('value', 'quota').text('Quota')
          );
        }

        if (!$(this).val().includes('custom_best_ball')) {
          $('.game-format.best-ball').addClass('d-none');
        }

        $('#game_type_game_type').trigger('change');
      })
      .trigger('change');
  };

  if (typeof window !== 'undefined') {
    window.outingsEventsGamesConfigurationsApp =
      outingsEventsGamesConfigurationsApp;
  }
})();
